// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Wfqo","upload":"Small_upload__2bhMQ","imageWrap":"Small_imageWrap__2xkdx","removeBtn":"Small_removeBtn__1pEZv"};